import { render, staticRenderFns } from "./waterMark.vue?vue&type=template&id=18257d7b&"
import script from "./waterMark.vue?vue&type=script&lang=js&"
export * from "./waterMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports